import React from "react";
import "../../../pages/Admin/Queries.css";

/**
 * Builds the page-number buttons for the pagination bar, collapsing long runs
 * into "…" — same windowing as the Queries table.
 */
function buildPageWindow(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [];
  const add = (n) => { if (pages[pages.length - 1] !== n) pages.push(n); };
  add(1);
  if (current > 3) add("…");
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) add(i);
  if (current < total - 2) add("…");
  add(total);
  return pages;
}

/**
 * Queries-style pagination bar for user lists: "1–10 of N users", page-size
 * select, prev/next and windowed page numbers. Renders nothing when total is 0.
 */
function UserListPagination({ total = 0, currentPage, pageSize, onPageChange, onPageSizeChange }) {
  if (!total) return null;

  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const fromIdx = (currentPage - 1) * pageSize;
  const pageWindow = buildPageWindow(currentPage, pageCount);

  return (
    <div className="bq-pagination">
      <span className="bq-page-info">
        {fromIdx + 1}–{Math.min(fromIdx + pageSize, total)} of {total.toLocaleString()} users
      </span>
      <div className="bq-page-controls">
        <select
          className="bq-page-size-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {[10, 20, 50].map((n) => (
            <option key={n} value={n}>{n} / page</option>
          ))}
        </select>
        <button
          className="bq-page-btn"
          aria-label="Previous page"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        {pageWindow.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="bq-page-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`bq-page-num-btn${p === currentPage ? " active" : ""}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}
        <button
          className="bq-page-btn"
          aria-label="Next page"
          disabled={currentPage >= pageCount}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default UserListPagination;
